// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"8bfa4c5c","459":"beca793f"}[chunkId] + ".chunk.js";
};